import React from "react";

export const FaceBook = () => (
  <svg
    width="31"
    height="31"
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.0037 15.0938C30.0037 6.7575 23.2875 0 15.0037 0C6.71625 0.001875 0 6.7575 0 15.0956C0 22.6275 5.48625 28.8712 12.6562 30.0037V19.4569H8.85V15.0956H12.66V11.7675C12.66 7.98563 14.9006 5.89687 18.3263 5.89687C19.9687 5.89687 21.6844 6.19125 21.6844 6.19125V9.90375H19.7925C17.9306 9.90375 17.3494 11.0681 17.3494 12.2625V15.0938H21.5081L20.8444 19.455H17.3475V30.0019C24.5175 28.8694 30.0037 22.6256 30.0037 15.0938Z"
      fill="white"
    />
  </svg>
);

export const Instagram = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.6875 15C19.6875 16.2432 19.1936 17.4355 18.3146 18.3146C17.4355 19.1936 16.2432 19.6875 15 19.6875C13.7568 19.6875 12.5645 19.1936 11.6854 18.3146C10.8064 17.4355 10.3125 16.2432 10.3125 15C10.3125 14.7328 10.3406 14.4719 10.3891 14.2187H8.75V20.4641C8.75 20.8984 9.10156 21.25 9.53594 21.25H20.4656C20.6738 21.2496 20.8733 21.1666 21.0204 21.0193C21.1674 20.8719 21.25 20.6722 21.25 20.4641V14.2187H19.6109C19.6594 14.4719 19.6875 14.7328 19.6875 15ZM15 18.125C15.4105 18.1249 15.8169 18.0439 16.1961 17.8868C16.5753 17.7296 16.9198 17.4993 17.21 17.2089C17.5002 16.9186 17.7304 16.574 17.8874 16.1947C18.0444 15.8154 18.1251 15.4089 18.125 14.9984C18.1249 14.588 18.0439 14.1815 17.8868 13.8023C17.7296 13.4231 17.4993 13.0786 17.2089 12.7884C16.9186 12.4982 16.574 12.2681 16.1947 12.1111C15.8154 11.9541 15.4089 11.8733 14.9984 11.8734C14.1694 11.8736 13.3745 12.2032 12.7884 12.7895C12.2024 13.3759 11.8732 14.171 11.8734 15C11.8736 15.829 12.2032 16.624 12.7895 17.21C13.3759 17.7961 14.171 18.1252 15 18.125ZM18.75 11.7187H20.6234C20.7479 11.7188 20.8673 11.6694 20.9554 11.5816C21.0436 11.4937 21.0933 11.3745 21.0937 11.25V9.37656C21.0937 9.25183 21.0442 9.1322 20.956 9.044C20.8678 8.9558 20.7482 8.90625 20.6234 8.90625H18.75C18.6253 8.90625 18.5056 8.9558 18.4174 9.044C18.3292 9.1322 18.2797 9.25183 18.2797 9.37656V11.25C18.2812 11.5078 18.4922 11.7187 18.75 11.7187ZM15 0C11.0218 0 7.20644 1.58035 4.3934 4.3934C1.58035 7.20644 0 11.0218 0 15C0 18.9782 1.58035 22.7936 4.3934 25.6066C7.20644 28.4196 11.0218 30 15 30C16.9698 30 18.9204 29.612 20.7403 28.8582C22.5601 28.1044 24.2137 26.9995 25.6066 25.6066C26.9995 24.2137 28.1044 22.5601 28.8582 20.7403C29.612 18.9204 30 16.9698 30 15C30 13.0302 29.612 11.0796 28.8582 9.25975C28.1044 7.43986 26.9995 5.78628 25.6066 4.3934C24.2137 3.00052 22.5601 1.89563 20.7403 1.14181C18.9204 0.387986 16.9698 0 15 0ZM22.8125 21.0766C22.8125 22.0312 22.0312 22.8125 21.0766 22.8125H8.92344C7.96875 22.8125 7.1875 22.0312 7.1875 21.0766V8.92344C7.1875 7.96875 7.96875 7.1875 8.92344 7.1875H21.0766C22.0312 7.1875 22.8125 7.96875 22.8125 8.92344V21.0766Z"
      fill="white"
    />
  </svg>
);

export const Twitter = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 0C6.71562 0 0 6.71562 0 15C0 23.2844 6.71562 30 15 30C23.2844 30 30 23.2844 30 15C30 6.71562 23.2844 0 15 0ZM21.1016 12.2875C21.1078 12.4156 21.1094 12.5437 21.1094 12.6687C21.1094 16.575 18.1391 21.0766 12.7047 21.0766C11.0989 21.0792 9.52651 20.618 8.17656 19.7484C8.40625 19.7766 8.64219 19.7875 8.88125 19.7875C10.2656 19.7875 11.5391 19.3172 12.55 18.5234C11.9339 18.5113 11.337 18.3073 10.8424 17.9399C10.3477 17.5724 9.98008 17.0598 9.79062 16.4734C10.2331 16.5576 10.6888 16.5399 11.1234 16.4219C10.4548 16.2867 9.85343 15.9243 9.42142 15.3963C8.9894 14.8684 8.75329 14.2072 8.75312 13.525V13.4891C9.15156 13.7094 9.60781 13.8438 10.0922 13.8594C9.46531 13.4421 9.02154 12.801 8.85163 12.0674C8.68172 11.3337 8.79852 10.5629 9.17812 9.9125C9.92024 10.825 10.8457 11.5715 11.8946 12.1036C12.9436 12.6357 14.0925 12.9417 15.2672 13.0016C15.1178 12.3677 15.1821 11.7022 15.45 11.1086C15.7179 10.515 16.1744 10.0265 16.7485 9.71916C17.3227 9.41178 17.9823 9.30269 18.6248 9.40886C19.2674 9.51503 19.8568 9.83051 20.3016 10.3062C20.9628 10.1754 21.5968 9.9329 22.1766 9.58906C21.9562 10.2736 21.4948 10.855 20.8781 11.225C21.4638 11.1545 22.0357 10.997 22.575 10.7578C22.1789 11.3514 21.6799 11.8694 21.1016 12.2875Z"
      fill="white"
    />
  </svg>
);

export const Linkedin = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 0C6.71562 0 0 6.71562 0 15C0 23.2844 6.71562 30 15 30C23.2844 30 30 23.2844 30 15C30 6.71562 23.2844 0 15 0ZM11.3281 21.2172H8.29062V11.4422H11.3281V21.2172ZM9.79062 10.2422C8.83125 10.2422 8.21094 9.5625 8.21094 8.72187C8.21094 7.86406 8.85 7.20469 9.82969 7.20469C10.8094 7.20469 11.4094 7.86406 11.4281 8.72187C11.4281 9.5625 10.8094 10.2422 9.79062 10.2422ZM22.4219 21.2172H19.3844V15.8C19.3844 14.5391 18.9437 13.6828 17.8453 13.6828C17.0063 13.6828 16.5078 14.2625 16.2875 14.8203C16.2062 15.0188 16.1859 15.3 16.1859 15.5797V21.2156H13.1469V14.5594C13.1469 13.3391 13.1078 12.3187 13.0672 11.4406H15.7062L15.8453 12.7984H15.9062C16.3062 12.1609 17.2859 11.2203 18.925 11.2203C20.9234 11.2203 22.4219 12.5594 22.4219 15.4375V21.2172Z"
      fill="white"
    />
  </svg>
);

export const Donate = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2945 7.765L9.5 10H5.75V9.25H8.79875C8.86658 9.24996 8.93313 9.23153 8.99132 9.19666C9.0495 9.1618 9.09714 9.1118 9.12915 9.052C9.16117 8.9922 9.17637 8.92484 9.17313 8.85708C9.16988 8.78933 9.14833 8.72372 9.11075 8.66725L8.44475 7.66825C8.30812 7.46261 8.12273 7.29397 7.90511 7.17737C7.68748 7.06077 7.44439 6.99984 7.1975 7H1.25C1.05109 7 0.860322 7.07902 0.71967 7.21967C0.579018 7.36032 0.5 7.55109 0.5 7.75V12.25C0.5 12.6478 0.658035 13.0294 0.93934 13.3107C1.22064 13.592 1.60217 13.75 2 13.75H9.22925C9.54995 13.7501 9.86697 13.6816 10.159 13.5491C10.4511 13.4167 10.7115 13.2233 10.9227 12.982L15.5 7.75L14.411 7.387C14.0547 7.26824 13.6743 7.24061 13.3046 7.30664C12.9349 7.37267 12.5876 7.53025 12.2945 7.765ZM13.4435 3.5425C13.7817 3.19375 13.991 2.7115 13.991 2.179C13.991 1.6465 13.7817 1.16425 13.4435 0.8155C13.2724 0.636984 13.0671 0.494872 12.8397 0.397696C12.6124 0.30052 12.3677 0.250282 12.1205 0.25C12.1205 0.25 11.1875 0.24775 10.25 1.2145C9.3125 0.24775 8.3795 0.25 8.3795 0.25C8.13233 0.250314 7.88776 0.300492 7.66044 0.397531C7.43311 0.494569 7.2277 0.636473 7.0565 0.81475C6.71825 1.16425 6.509 1.64575 6.509 2.17825C6.509 2.71075 6.71825 3.19375 7.0565 3.54175L10.25 7L13.4435 3.5425Z"
      fill="black"
    />
  </svg>
);

export const Checkmark = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 0.53125C5.425 0.53125 0.53125 5.425 0.53125 11.5C0.53125 17.575 5.425 22.4688 11.5 22.4688C17.575 22.4688 22.4688 17.575 22.4688 11.5C22.4688 10.3204 22.3101 9.14341 21.8883 8.04569L20.518 9.39062C20.6868 10.0656 20.7821 10.7423 20.7821 11.5C20.7821 16.6486 16.6494 20.7812 11.5008 20.7812C6.35228 20.7812 2.21875 16.6486 2.21875 11.5C2.21875 6.35144 6.35144 2.21875 11.5 2.21875C14.0312 2.21875 16.3052 3.22703 17.9074 4.82931L19.0938 3.643C17.1531 1.70069 14.4531 0.53125 11.5 0.53125ZM21.0183 4.14334L11.5 13.6625L7.88791 10.0496L6.67459 11.2629L10.8933 15.4817L11.5 16.0613L12.1067 15.4817L22.2317 5.35666L21.0183 4.14334Z"
      fill="#F18404"
    />
  </svg>
);

export const ChatWithUs = () => (
  <svg
    width="255"
    height="218"
    viewBox="0 0 255 218"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M95.1031 218C95.1031 218 70.8809 218 70.8809 193.778V24.2222C70.8809 24.2222 70.8809 0 95.1031 0H179.881C179.881 0 204.103 0 204.103 24.2222V193.778C204.103 193.778 204.103 218 179.881 218H95.1031Z"
      fill="#31373D"
    />
    <path
      d="M82.9922 30.2773H191.992V187.722H82.9922V30.2773Z"
      fill="#F2F2F2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M254.417 162.078C254.417 163.671 253.784 165.199 252.657 166.326C251.53 167.453 250.002 168.086 248.409 168.086H175.311C173.717 168.086 172.189 167.453 171.062 166.326C169.936 165.199 169.303 163.671 169.303 162.078V110.008C169.303 108.415 169.936 106.886 171.062 105.76C172.189 104.633 173.717 104 175.311 104H248.409C250.002 104 251.53 104.633 252.657 105.76C253.784 106.886 254.417 108.415 254.417 110.008V162.078Z"
      fill="#F4C5A9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M241.401 175.095C241.401 178.322 238.657 181.103 235.393 181.103H222.376C221.261 181.103 220.373 181.858 220.373 183.106V201.13C220.373 201.869 220.12 202.131 219.455 202.131C219.222 202.131 218.983 201.977 218.589 201.674L194.589 183.106C191.585 181.103 188.452 181.097 188.452 181.097L162.197 181.095C158.933 181.095 156.287 178.479 156.287 175.251V124.058C156.287 120.832 159.187 118.003 162.295 118.019H235.393C238.96 118.019 241.401 120.8 241.401 124.027V175.095Z"
      fill="#F18404"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.123 72.3326C12.123 73.9275 12.7566 75.4571 13.8844 76.5849C15.0122 77.7127 16.5418 78.3463 18.1367 78.3463H91.3046C92.8995 78.3463 94.4292 77.7127 95.557 76.5849C96.6848 75.4571 97.3184 73.9275 97.3184 72.3326V20.213C97.3184 18.6181 96.6848 17.0884 95.557 15.9606C94.4292 14.8328 92.8995 14.1992 91.3046 14.1992H18.1367C16.5418 14.1992 15.0122 14.8328 13.8844 15.9606C12.7566 17.0884 12.123 18.6181 12.123 20.213V72.3326Z"
      fill="#F18404"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.929596 84.5266C0.929596 87.757 3.6759 90.5404 6.94339 90.5404H19.9733C21.0888 90.5404 21.9779 91.2961 21.9779 92.545V110.586C21.9779 111.326 22.2315 111.589 22.897 111.589C23.1295 111.589 23.3691 111.434 23.764 111.131L47.7861 92.545C50.793 90.5404 53.9292 90.5344 53.9292 90.5344L80.2094 90.5324C83.4769 90.5324 86.125 87.9134 86.125 84.683V33.4404C86.125 30.212 83.2223 27.3795 80.1112 27.3956H6.94339C3.37321 27.3956 0.929596 30.18 0.929596 33.4094V84.5266Z"
      fill="#F4C5A9"
    />
  </svg>
);

export const Carbon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.21801 1.98779H2.05859V7.14721H3.20513V3.13433H7.21801V1.98779Z"
      fill="white"
    />
    <path
      d="M2.05859 12.8799V18.0393H7.21801V16.8928H3.20513V12.8799H2.05859Z"
      fill="white"
    />
    <path
      d="M18.1106 7.14721V1.98779H12.9512V3.13433H16.9641V7.14721H18.1106Z"
      fill="white"
    />
    <path
      d="M12.9512 18.0393H18.1106V12.8799H16.9641V16.8928H12.9512V18.0393Z"
      fill="white"
    />
    <path
      d="M15.5246 6.64847L10.3652 3.78213C10.278 3.73181 10.1792 3.70532 10.0785 3.70532C9.97791 3.70532 9.87906 3.73181 9.79191 3.78213L4.63249 6.64847C4.54607 6.6997 4.47464 6.77274 4.42534 6.86027C4.37604 6.9478 4.35061 7.04676 4.35159 7.14721V12.8799C4.35177 12.9815 4.37893 13.0812 4.4303 13.1688C4.48167 13.2565 4.55541 13.3289 4.64396 13.3786L9.80337 16.245C9.89052 16.2953 9.98938 16.3218 10.09 16.3218C10.1906 16.3218 10.2895 16.2953 10.3766 16.245L15.5361 13.3786C15.6225 13.3274 15.6939 13.2544 15.7432 13.1668C15.7925 13.0793 15.8179 12.9804 15.817 12.8799V7.14721C15.8168 7.04563 15.7896 6.94592 15.7383 6.85829C15.6869 6.77065 15.6131 6.69824 15.5246 6.64847ZM10.0843 4.9344L14.0628 7.14721L10.0843 9.36003L6.10579 7.14721L10.0843 4.9344ZM5.49813 8.12177L9.51101 10.3518V14.7717L5.49813 12.5417V8.12177ZM10.6575 14.7717V10.3518L14.6704 8.12177V12.5417L10.6575 14.7717Z"
      fill="white"
    />
  </svg>
);
